import { errorActions } from './error';
import { transactionTypesConstants } from '../constants/transaction_types';
import { transactionTypesService } from '../services/transaction_types';
import { transactionTypesFormatter } from '../formatters/transaction_types';

export const transactionTypesActions = {
    getVendorStats,
    getTransactionTypes,
    changeVendorStatus
};

function getVendorStats() {
    return ( dispatch, getState ) => {
        dispatch(request());
        const globalFilter = getState().filter.global;
        transactionTypesService.getVendorStats(globalFilter)
            .then(
                transactionTypes => {
                    return transactionTypesFormatter.formatVendorStats(transactionTypes);
                    //
                }
            )
            .then(stats=>{
                let {result, dates} = stats;
                transactionTypesService.getVendorStatuses(globalFilter)
                .then(statuses=>{
                    result = transactionTypesFormatter.formatVendorStatuses(result, statuses.data);
                    return dispatch(success(result, dates));
                })
            })
            .catch(error => {
                dispatch(failure('error'))
            })
    };

    function request() { return { type: transactionTypesConstants.GET_TRANSACTION_TYPE_STATS_REQUEST } }
    function success(transactionTypes, dates) { return { type: transactionTypesConstants.GET_TRANSACTION_TYPE_STATS_SUCCESS, transactionTypes, dates } }
    function failure(error) { return { type: transactionTypesConstants.GET_TRANSACTION_TYPE_STATS_FAILURE, error } }
}

function changeVendorStatus(vendor, silo, status, vendorName) {
    return ( dispatch, getState ) => {
        dispatch(request());
        const params = {vendor_id: vendor, silo_code: silo, status, vendor_name: vendorName};
        
        transactionTypesService.changeVendorStatus(params)
            .then(
                res => {
                    const successMessage = (status == 'approved') ? 'Thank you for approving the data security policy' : 'You have successfully revoked your credentials'; 
                    
                    dispatch(success());
                    dispatch(errorActions.setSuccessMessage(successMessage));
                    dispatch(getVendorStats());
                },
                error => {
                    dispatch(failure())
                    dispatch(errorActions.setErrorMessage('error saving status'))
                }
            );
 
    };
    function request() { return { type: transactionTypesConstants.CHANGE_TRANSACTION_TYPE_STATUS_REQUEST } }
    function success() { return { type: transactionTypesConstants.CHANGE_TRANSACTION_TYPE_STATUS_SUCCESS } }
    function failure() { return { type: transactionTypesConstants.CHANGE_TRANSACTION_TYPE_STATUS_FAILURE } }

}


function getTransactionTypes() {
    return ( dispatch, getState ) => {
        dispatch(request());
        transactionTypesService.getTransactionTypes()
        .then(
            transactionTypes => {
                transactionTypes = transactionTypesFormatter.formatTransactionTypes(transactionTypes);
                return dispatch(success(transactionTypes));
                
            }
        )
    };

    function request() { return { type: transactionTypesConstants.GET_TRANSACTION_TYPES_REQUEST } }
    function success(transactionTypes) { return { type: transactionTypesConstants.GET_TRANSACTION_TYPES_SUCCESS, transactionTypes } }
    function failure(error) { return { type: transactionTypesConstants.GET_TRANSACTION_TYPES_FAILURE, error } }
}
